import { render } from "./BooksView.vue?vue&type=template&id=2aceff7e"
import script from "./BooksView.vue?vue&type=script&lang=js"
export * from "./BooksView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__